export const getNodeContent = (graph, nodeId) => {
  const selectedNode = graph.nodes.find((node) => {
    return node.id === nodeId;
  });

  return selectedNode;
};
